const vuexModules = {
    namespaced: true,
    state: {
        isLoading: true
    },
    mutations: {
        setIsLoading (state, isLoading) {
            state.isLoading = isLoading;
        }
    }
};

export default vuexModules;
